export default __webpack_public_path__ + "static/media/EmptyOrder.76bf3811.svg";